export default __webpack_public_path__ + "static/media/maintain.f8303e40.jpeg";